import React from "react";
import * as ReactDOM from "react-dom/client";
import "./landing-shared.entry.jsx";
const SiteNav = globalThis.SiteNav ?? globalThis.window?.SiteNav;
const SiteFooter = globalThis.SiteFooter ?? globalThis.window?.SiteFooter;
// named.network Landing Page

const { useState, useEffect, useRef } = React;

// ========= Icons =========
const Icon = {
  arrow: (p) => <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...p}><path d="M3 6h6m0 0L6 3m3 3L6 9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="square"/></svg>,
  arrowDiag: (p) => <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...p}><path d="M3 9L9 3M9 3H4M9 3V8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="square"/></svg>,
  copy: (p) => <svg width="11" height="11" viewBox="0 0 12 12" fill="none" {...p}><rect x="3" y="3" width="7" height="7" stroke="currentColor" strokeWidth="1"/><path d="M2 8V2h6" stroke="currentColor" strokeWidth="1"/></svg>,
  lock: (p) => <svg width="9" height="9" viewBox="0 0 10 10" fill="none" {...p}><rect x="2" y="5" width="6" height="4" stroke="currentColor" strokeWidth="1"/><path d="M3 5V3.5C3 2.4 3.9 1.5 5 1.5C6.1 1.5 7 2.4 7 3.5V5" stroke="currentColor" strokeWidth="1"/></svg>,
  device: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="18" height="12" stroke="currentColor" strokeWidth="1.4"/><path d="M9 21h6M12 17v4" stroke="currentColor" strokeWidth="1.4"/></svg>,
  dns: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.4"/><path d="M3 12h18M12 3a13 13 0 0 1 0 18M12 3a13 13 0 0 0 0 18" stroke="currentColor" strokeWidth="1.4"/></svg>,
  network: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="6" cy="6" r="2.5" stroke="currentColor" strokeWidth="1.4"/><circle cx="18" cy="6" r="2.5" stroke="currentColor" strokeWidth="1.4"/><circle cx="12" cy="18" r="2.5" stroke="currentColor" strokeWidth="1.4"/><path d="M8 7l3 8m5-8l-3 8" stroke="currentColor" strokeWidth="1.4"/></svg>,
  bot: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="4" y="7" width="16" height="13" stroke="currentColor" strokeWidth="1.4"/><circle cx="9" cy="13" r="1.2" fill="currentColor"/><circle cx="15" cy="13" r="1.2" fill="currentColor"/><path d="M12 4v3" stroke="currentColor" strokeWidth="1.4"/></svg>,
  gateway: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 20V8l8-4 8 4v12" stroke="currentColor" strokeWidth="1.4"/><path d="M9 20v-6h6v6" stroke="currentColor" strokeWidth="1.4"/></svg>,
  exit: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M14 4h6v16h-6M3 12h12m0 0l-4-4m4 4l-4 4" stroke="currentColor" strokeWidth="1.4"/></svg>,
  app: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" stroke="currentColor" strokeWidth="1.4"/><path d="M3 8h18M8 3v18" stroke="currentColor" strokeWidth="1.4"/></svg>,
  share: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="6" cy="12" r="2.5" stroke="currentColor" strokeWidth="1.4"/><circle cx="18" cy="6" r="2.5" stroke="currentColor" strokeWidth="1.4"/><circle cx="18" cy="18" r="2.5" stroke="currentColor" strokeWidth="1.4"/><path d="M8 11l8-4M8 13l8 4" stroke="currentColor" strokeWidth="1.4"/></svg>,
};

// ========= Hero =========
function Hero() {
  const [tab, setTab] = useState('macos');
  const cmds = {
    macos: 'curl -fsSL https://named.network/install.sh | sh',
    linux: 'curl -fsSL https://named.network/install.sh | sh',
    windows: 'irm https://named.network/install.ps1 | iex',
    docker: 'docker run -d --name namedn-agent namedn/agent',
  };

  return (
    <section className="section section-dark hero">
      <div className="dark-grid"></div>
      <div className="dark-glow"></div>
      <div className="container">
        <div className="hero-grid">
          <div className="reveal">
            <span className="section-label">Private access for everyone</span>
            <h1>
              Share local apps <em>privately</em>,<br/>without opening<br/>ports.
            </h1>
            <p className="hero-sub">
              named.network helps you share local apps privately with people you trust — safely, without exposing ports, configuring DNS, or buying a static IP. Protect one app or run private access for a whole team from one workspace.
            </p>
            <div className="hero-ctas">
              <a href="https://app.named.network/signup" className="btn btn-accent btn-lg"><span>Create your workspace <Icon.arrow /></span></a>
              <a href="#how" className="btn btn-on-dark btn-lg"><span>See how it works</span></a>
            </div>
            <div className="hero-meta">
              <span><span className="dot"></span>Free for personal use</span>
              <span><span className="dot"></span>No port forwarding</span>
              <span><span className="dot"></span>Identity-based access</span>
            </div>
          </div>

          <div className="reveal" style={{ animationDelay: '120ms' }}>
            <div className="terminal-card">
              <div className="terminal-head">
                <div className="terminal-tabs">
                  {['macos','linux','windows','docker'].map(p => (
                    <button key={p} className={`terminal-tab ${tab===p?'active':''}`} onClick={() => setTab(p)}>{p}</button>
                  ))}
                </div>
                <span className="terminal-meta">install · 1 step</span>
              </div>
              <div className="terminal-body">
                <button className="copy"><Icon.copy /> copy</button>
                <div className="line-anim"><span className="prompt">$</span><span className="com">{cmds[tab]}</span></div>
                <div className="line-anim" style={{animationDelay:'400ms'}}><span className="out">→ Downloading named.network agent (8.2 MB)…</span></div>
                <div className="line-anim" style={{animationDelay:'700ms'}}><span className="out">→ Verifying signature… </span><span className="ok">ok</span></div>
                <div className="line-anim" style={{animationDelay:'1000ms'}}><span className="out">→ Joining workspace acme-co… </span><span className="ok">connected</span></div>
                <div className="line-anim" style={{animationDelay:'1300ms'}}><span className="out">→ Detected </span><span className="accent">3 local apps</span><span className="out">: grafana:3000, jupyter:8888, postgres:5432</span></div>
                <div className="line-anim" style={{animationDelay:'1700ms'}}><span className="prompt">$</span><span className="com cursor"></span></div>
              </div>
            </div>
            <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-dark-faint)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
              <span>One command. No account configured yet? <a href="https://app.named.network/signup" style={{ color: 'var(--accent)', textDecoration: 'underline', textDecorationStyle: 'dotted' }}>Sign up</a></span>
              <span>v 4.2.1</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ========= Live product preview =========
function ProductPreview() {
  return (
    <section className="section section-dark" id="product" style={{ paddingTop: 24 }}>
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 36, flexWrap: 'wrap', gap: 24 }}>
          <div>
            <span className="section-label">Product preview</span>
            <h2 className="display" style={{ fontSize: 'clamp(32px, 4vw, 52px)', margin: '14px 0 0', maxWidth: 720 }}>
              The dashboard you actually use, every day.
            </h2>
          </div>
          <p style={{ fontFamily: 'var(--font-mono)', fontSize: 14, color: 'var(--text-dark-muted)', maxWidth: 360, margin: 0 }}>
            Representative workspace view. Real product surface. Example data shown here. Click through to see the live product →
          </p>
        </div>

        <div className="browser" style={{ position: 'relative' }}>
          <div className="browser-bar">
            <div className="browser-dots"><span/><span/><span/></div>
            <div className="browser-url">
              <span className="lock"><Icon.lock /></span>
              app.named.network/dashboard
            </div>
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--text-dark-faint)', textTransform: 'uppercase' }}>workspace · acme-co</span>
          </div>
          <div style={{ position: 'relative', height: 520, overflow: 'hidden', background: 'var(--bg-dark-alt)' }}>
            {/* Mini dashboard mock */}
            <div style={{ display: 'grid', gridTemplateColumns: '180px 1fr', height: '100%' }}>
              {/* Sidebar */}
              <div style={{ borderRight: '1px solid var(--border-dark-subtle)', padding: '20px 14px', background: 'var(--bg-dark)' }}>
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--text-dark-faint)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 12 }}>CORE</div>
                {['Overview', 'Protected apps', 'Devices', 'Access', 'Billing'].map((it, i) => (
                  <div key={it} style={{ padding: '7px 10px', fontFamily: 'var(--font-mono)', fontSize: 12, color: i===1 ? 'var(--accent)' : 'var(--text-dark-secondary)', background: i===1 ? 'var(--accent-fade)' : 'transparent', borderLeft: i===1 ? '2px solid var(--accent)' : '2px solid transparent', marginBottom: 2 }}>
                    {it}
                  </div>
                ))}
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--text-dark-faint)', textTransform: 'uppercase', letterSpacing: '0.1em', margin: '20px 0 12px' }}>ADVANCED</div>
                {['Secure DNS', 'Private Network'].map((it) => (
                  <div key={it} style={{ padding: '7px 10px', fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-dark-muted)' }}>{it}</div>
                ))}
              </div>
              {/* Content */}
              <div style={{ padding: '24px 28px', overflow: 'hidden' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                  <div>
                    <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--text-dark-muted)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>PROTECTED APPS</div>
                    <div style={{ fontFamily: 'var(--font-sans)', fontSize: 28, letterSpacing: '-0.02em', marginTop: 8 }}>12 apps online</div>
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <div className="btn btn-on-dark" style={{ height: 30, padding: '0 12px', fontSize: 10 }}><span>+ Protect app</span></div>
                  </div>
                </div>
                {/* Apps table */}
                <div style={{ border: '1px solid var(--border-dark)', borderRadius: 3, background: 'var(--bg-dark-card)' }}>
                  {[
                    { name: 'grafana-prod', url: 'grafana.acme-co.named.network', host: 'mac-studio-01', status: 'ready', color: 'var(--success)' },
                    { name: 'postgres-staging', url: 'pg.acme-co.named.network', host: 'lin-server-04', status: 'ready', color: 'var(--success)' },
                    { name: 'jupyter-research', url: 'lab.acme-co.named.network', host: 'mac-studio-01', status: 'awaiting first check', color: 'var(--warning)' },
                    { name: 'internal-wiki', url: 'wiki.acme-co.named.network', host: 'lin-server-04', status: 'ready', color: 'var(--success)' },
                    { name: 'admin-dash', url: 'admin.acme-co.named.network', host: 'mac-mini-jp', status: 'agent offline', color: 'var(--danger)' },
                  ].map((row, i) => (
                    <div key={i} style={{ display: 'grid', gridTemplateColumns: '1.4fr 1.6fr 1fr 1fr', gap: 16, padding: '14px 18px', borderBottom: i < 4 ? '1px solid var(--border-dark-subtle)' : 'none', alignItems: 'center', fontFamily: 'var(--font-mono)', fontSize: 12 }}>
                      <span style={{ color: 'var(--text-dark-primary)' }}>{row.name}</span>
                      <span style={{ color: 'var(--accent)' }}>{row.url}</span>
                      <span style={{ color: 'var(--text-dark-muted)' }}>{row.host}</span>
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: row.color, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                        <span style={{ width: 6, height: 6, borderRadius: '50%', background: row.color, position: 'relative' }}>
                          {row.status === 'ready' && <span className="pulse-ring" style={{ position: 'absolute', inset: -2, borderRadius: '50%', background: row.color }}></span>}
                        </span>
                        {row.status}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* Fade bottom */}
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: 80, background: 'linear-gradient(to bottom, transparent, var(--bg-dark))', pointerEvents: 'none' }}></div>
          </div>
        </div>

        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <a href="https://app.named.network/login" className="btn btn-on-dark"><span>Open the live dashboard <Icon.arrow /></span></a>
        </div>
      </div>
    </section>
  );
}

// ========= How it works =========
function HowItWorks() {
  return (
    <section className="section section-light" id="how">
      <div className="container">
        <div className="section-h">
          <span className="section-label on-light">How it works</span>
          <h2>Three steps. No port forwarding.</h2>
          <p>Most "self-hosted" guides start by asking you to mess with your router. We don't. Install one tiny agent, pick the app you want to share, and we do the rest.</p>
        </div>

        <div className="steps-grid reveal">
          {[
            {
              num: '01',
              title: 'Install the agent',
              body: 'One command on the computer where your app already runs. The agent finds apps automatically — no config files.',
              viz: <StepInstallViz />
            },
            {
              num: '02',
              title: 'Pick an app to protect',
              body: "We list apps we found. Click one and we'll generate a private link that only people you invite can open.",
              viz: <StepProtectViz />
            },
            {
              num: '03',
              title: 'Share with people you trust',
              body: 'Invite by email. They sign in once and the app is just there — like any normal website, but private to your group.',
              viz: <StepShareViz />
            },
          ].map((s, i) => (
            <div key={s.num} className="step-card reveal" style={{ animationDelay: `${i*100}ms` }}>
              <div className="step-num"><span className="step-num-box">{s.num}</span><span>STEP {s.num}</span></div>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
              <div style={{ marginTop: 28, height: 140, position: 'relative' }}>{s.viz}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function StepInstallViz() {
  return (
    <div style={{ position: 'absolute', inset: 0, background: 'var(--bg-dark)', borderRadius: 3, padding: 14, fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-dark-secondary)', overflow: 'hidden' }}>
      <div style={{ color: 'var(--text-dark-faint)', fontSize: 9, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 10 }}>~ /home/dev</div>
      <div><span style={{ color: 'var(--accent)' }}>$ </span>curl named.network | sh</div>
      <div style={{ color: 'var(--text-dark-muted)', marginTop: 6 }}>→ agent installed</div>
      <div style={{ color: 'var(--success)', marginTop: 2 }}>● ready</div>
      <div style={{ position: 'absolute', bottom: 14, left: 14, right: 14, height: 2, background: 'var(--border-dark)', borderRadius: 2 }}>
        <div style={{ width: '100%', height: '100%', background: 'var(--accent)', animation: 'progressFill 2s ease-out' }}></div>
      </div>
      <style>{`@keyframes progressFill { from { width: 0; } to { width: 100%; } }`}</style>
    </div>
  );
}

function StepProtectViz() {
  return (
    <div style={{ position: 'absolute', inset: 0, background: 'var(--bg-light)', border: '1px solid var(--border-light)', borderRadius: 3, padding: 12, overflow: 'hidden' }}>
      {[
        { name: 'grafana', port: ':3000', selected: true },
        { name: 'jupyter', port: ':8888', selected: false },
        { name: 'postgres', port: ':5432', selected: false },
      ].map((a) => (
        <div key={a.name} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', fontFamily: 'var(--font-mono)', fontSize: 11, marginBottom: 4, border: a.selected ? '1px solid var(--accent)' : '1px solid transparent', background: a.selected ? 'var(--accent-fade)' : 'transparent', borderRadius: 2 }}>
          <span style={{ color: a.selected ? 'var(--accent)' : 'var(--text-light-primary)' }}>{a.name}{a.port}</span>
          {a.selected && <span style={{ fontSize: 9, color: 'var(--accent)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>protect →</span>}
        </div>
      ))}
    </div>
  );
}

function StepShareViz() {
  return (
    <div style={{ position: 'absolute', inset: 0, background: 'var(--bg-light)', border: '1px solid var(--border-light)', borderRadius: 3, padding: 14, fontFamily: 'var(--font-mono)', fontSize: 11, overflow: 'hidden' }}>
      <div style={{ color: 'var(--text-light-muted)', fontSize: 9, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 10 }}>Invite to grafana-prod</div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
        <input aria-label="Invitee email example" readOnly defaultValue="alex@friend.dev" style={{ flex: 1, padding: '6px 8px', fontFamily: 'var(--font-mono)', fontSize: 11, background: 'var(--bg-light-card)', border: '1px solid var(--border-light)', color: 'var(--text-light-primary)', borderRadius: 2 }} />
        <button style={{ padding: '0 10px', fontFamily: 'var(--font-mono)', fontSize: 9, background: 'var(--accent)', color: '#fff', border: 'none', textTransform: 'uppercase', letterSpacing: '0.06em', cursor: 'pointer', borderRadius: 2 }}>Send</button>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px', background: 'var(--bg-light-card)', border: '1px solid var(--border-light)', borderRadius: 2 }}>
        <span style={{ width: 18, height: 18, background: 'var(--bg-light-alt)', border: '1px solid var(--border-light)', borderRadius: '50%', display: 'grid', placeItems: 'center', fontSize: 9 }}>A</span>
        <span style={{ flex: 1, color: 'var(--text-light-primary)' }}>alex@friend.dev</span>
        <span style={{ color: 'var(--success)', fontSize: 9, textTransform: 'uppercase', letterSpacing: '0.06em' }}>● invited</span>
      </div>
    </div>
  );
}

// ========= Service block =========
function ServiceBlock({ flip, label, title, lead, problem, solution, cta, href, viz, dark }) {
  const sectionClass = `section ${dark ? 'section-dark' : 'section-light-alt'} service ${dark ? 'dark' : ''}`;
  return (
    <section className={sectionClass}>
      {dark && <div className="dark-grid"></div>}
      <div className="container">
        <div className={`service-grid ${flip ? 'flip' : ''}`}>
          <div className="service-copy reveal">
            <span className={`section-label ${dark ? '' : 'on-light'}`}>{label}</span>
            <h2>{title}</h2>
            <p style={{ fontFamily: 'var(--font-mono)', fontSize: 15, color: dark ? 'var(--text-dark-secondary)' : 'var(--text-light-secondary)', marginTop: 18, lineHeight: 1.6, maxWidth: 480 }}>
              {lead}
            </p>
            <div className="problem-solution">
              <div className="ps-row">
                <div className="ps-tag problem"><span className="ps-dot"></span>The usual way</div>
                <div className="ps-text" style={{ color: dark ? 'var(--text-dark-secondary)' : 'var(--text-light-secondary)' }}>{problem}</div>
              </div>
              <div className="ps-row">
                <div className="ps-tag solution"><span className="ps-dot"></span>With named.network</div>
                <div className="ps-text">{solution}</div>
              </div>
            </div>
            <a href={href} className="service-link">{cta} <Icon.arrow /></a>
          </div>
          <div className="reveal" style={{ animationDelay: '120ms' }}>{viz}</div>
        </div>
      </div>
    </section>
  );
}

// ========= Service viz components =========
function VizProtectedApp() {
  return (
    <div className="viz-frame" data-label="LIVE TUNNEL · grafana-prod">
      <span className="viz-corner tl"></span><span className="viz-corner tr"></span>
      <span className="viz-corner bl"></span><span className="viz-corner br"></span>
      <svg viewBox="0 0 400 300" className="route-svg" style={{ width: '100%', height: '100%' }}>
        {/* Friend (left) */}
        <g transform="translate(40,140)">
          <rect x="-30" y="-22" width="60" height="44" fill="var(--bg-light-card)" stroke="var(--border-light)" strokeWidth="1"/>
          <text x="0" y="-32" fontFamily="var(--font-mono)" fontSize="9" fill="var(--text-light-muted)" textAnchor="middle" letterSpacing="1">FRIEND</text>
          <circle cx="0" cy="0" r="3" fill="var(--accent)"/>
        </g>
        {/* Tunnel cloud middle */}
        <g transform="translate(200,150)">
          <rect x="-60" y="-50" width="120" height="100" fill="none" stroke="var(--accent)" strokeWidth="1" strokeDasharray="4 4"/>
          <text x="0" y="-60" fontFamily="var(--font-mono)" fontSize="9" fill="var(--accent)" textAnchor="middle" letterSpacing="1">NAMED.NETWORK MESH</text>
          <circle cx="0" cy="0" r="20" fill="var(--accent-fade)" stroke="var(--accent)" strokeWidth="1"/>
          <text x="0" y="4" fontFamily="var(--font-mono)" fontSize="10" fill="var(--accent)" textAnchor="middle">tls</text>
        </g>
        {/* Your computer (right) */}
        <g transform="translate(360,140)">
          <rect x="-30" y="-22" width="60" height="44" fill="var(--bg-light-card)" stroke="var(--border-light)" strokeWidth="1"/>
          <text x="0" y="-32" fontFamily="var(--font-mono)" fontSize="9" fill="var(--text-light-muted)" textAnchor="middle" letterSpacing="1">YOUR MAC</text>
          <text x="0" y="38" fontFamily="var(--font-mono)" fontSize="9" fill="var(--text-light-muted)" textAnchor="middle">grafana :3000</text>
          <circle cx="0" cy="0" r="3" fill="var(--success)"/>
        </g>
        {/* Lines */}
        <path d="M70 140 L140 140" className="route-line live"/>
        <path d="M260 140 L330 140" className="route-line live"/>
        {/* No router / no port forward annotation */}
        <g transform="translate(200,250)">
          <text x="0" y="0" fontFamily="var(--font-mono)" fontSize="9" fill="var(--text-light-muted)" textAnchor="middle" letterSpacing="1">NO PORT FORWARDING · NO STATIC IP · NO DNS</text>
        </g>
      </svg>
    </div>
  );
}

function VizDevices() {
  return (
    <div className="viz-frame" data-label="ENROLLED COMPUTERS">
      <span className="viz-corner tl"></span><span className="viz-corner tr"></span>
      <span className="viz-corner bl"></span><span className="viz-corner br"></span>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {[
          { name: 'mac-studio-01', os: 'macOS 14.4', status: 'ready', heart: 'Last beat 0.3s', col: 'var(--success)' },
          { name: 'lin-server-04', os: 'Ubuntu 22.04', status: 'ready', heart: 'Last beat 0.8s', col: 'var(--success)' },
          { name: 'mac-mini-jp', os: 'macOS 14.2', status: 'connecting', heart: 'Last beat 11s', col: 'var(--warning)' },
          { name: 'lab-pc-win11', os: 'Windows 11', status: 'off', heart: 'Last beat 2h ago', col: 'var(--text-light-faint)' },
        ].map((d, i) => (
          <div key={i} style={{ display: 'grid', gridTemplateColumns: '24px 1fr auto', gap: 12, alignItems: 'center', padding: '12px 14px', background: 'var(--bg-light-card)', border: '1px solid var(--border-light)', borderRadius: 2 }}>
            <div style={{ width: 24, height: 24, border: '1px solid var(--border-light)', display: 'grid', placeItems: 'center', color: 'var(--text-light-muted)' }}><Icon.device /></div>
            <div>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-light-primary)' }}>{d.name}</div>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--text-light-muted)', marginTop: 2 }}>{d.os} · {d.heart}</div>
            </div>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontFamily: 'var(--font-mono)', fontSize: 10, color: d.col, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
              <span style={{ position: 'relative', width: 6, height: 6, borderRadius: '50%', background: d.col }}>
                {d.status === 'ready' && <span className="pulse-ring" style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: d.col }}></span>}
              </span>
              {d.status}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function VizAccess() {
  return (
    <div className="viz-frame" data-label="ACCESS · grafana-prod">
      <span className="viz-corner tl"></span><span className="viz-corner tr"></span>
      <span className="viz-corner bl"></span><span className="viz-corner br"></span>
      <div style={{ marginBottom: 16, fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-light-muted)' }}>
        <div style={{ marginBottom: 8 }}>
          <input aria-label="Access request email example" readOnly defaultValue="newperson@friend.dev" style={{ width: '100%', padding: '10px 12px', fontFamily: 'var(--font-mono)', fontSize: 12, background: 'var(--bg-light-card)', border: '1px solid var(--border-light)', borderRadius: 2 }} />
        </div>
      </div>
      {[
        { email: 'alex@friend.dev', role: 'shared access', when: '2 days ago', avatar: 'A', col: 'var(--success)' },
        { email: 'priya@team.io', role: 'workspace member', when: 'yesterday', avatar: 'P', col: 'var(--success)' },
        { email: 'jin@team.io', role: 'invite sent', when: '4h ago', avatar: 'J', col: 'var(--warning)', pending: true },
      ].map((p, i) => (
        <div key={i} style={{ display: 'grid', gridTemplateColumns: '32px 1fr auto auto', gap: 12, alignItems: 'center', padding: '10px 12px', background: 'var(--bg-light-card)', border: '1px solid var(--border-light)', borderRadius: 2, marginBottom: 6 }}>
          <span style={{ width: 28, height: 28, background: 'var(--bg-light-alt)', border: '1px solid var(--border-light)', borderRadius: '50%', display: 'grid', placeItems: 'center', fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-light-secondary)' }}>{p.avatar}</span>
          <div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 12 }}>{p.email}</div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--text-light-muted)', marginTop: 2 }}>{p.role} · {p.when}</div>
          </div>
          {p.pending && <span style={{ fontFamily: 'var(--font-mono)', fontSize: 9, color: 'var(--warning)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>● pending</span>}
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-light-muted)' }}>···</span>
        </div>
      ))}
    </div>
  );
}

function VizDNS() {
  return (
    <div className="viz-frame" data-label="DNS PROFILE · home" style={{ background: 'var(--bg-dark-alt)' }}>
      <span className="viz-corner tl"></span><span className="viz-corner tr"></span>
      <span className="viz-corner bl"></span><span className="viz-corner br"></span>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
        {[
          { label: 'Blocked today', value: '14,832', col: 'var(--accent)' },
          { label: 'Top category', value: 'ads · 67%', col: 'var(--text-dark-primary)' },
        ].map((m, i) => (
          <div key={i} style={{ padding: 14, background: 'var(--bg-dark-card)', border: '1px solid var(--border-dark)', borderRadius: 2 }}>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 9, color: 'var(--text-dark-muted)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>{m.label}</div>
            <div style={{ fontFamily: 'var(--font-sans)', fontSize: 24, color: m.col, marginTop: 6, letterSpacing: '-0.01em' }}>{m.value}</div>
          </div>
        ))}
      </div>
      <div style={{ background: 'var(--bg-dark-card)', border: '1px solid var(--border-dark)', borderRadius: 2 }}>
        {[
          { d: 'doubleclick.net', c: 'ads', t: '0.2s', blocked: true },
          { d: 'github.com', c: 'allowed', t: '0.4s', blocked: false },
          { d: 'tracking.io', c: 'trackers', t: '0.6s', blocked: true },
          { d: 'malware-host.xyz', c: 'malware', t: '1.1s', blocked: true },
          { d: 'cdn.cloudflare.com', c: 'allowed', t: '1.3s', blocked: false },
        ].map((q, i, arr) => (
          <div key={i} style={{ display: 'grid', gridTemplateColumns: '14px 1fr auto auto', gap: 10, alignItems: 'center', padding: '8px 12px', borderBottom: i < arr.length-1 ? '1px solid var(--border-dark-subtle)' : 'none', fontFamily: 'var(--font-mono)', fontSize: 11 }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: q.blocked ? 'var(--accent)' : 'var(--success)' }}></span>
            <span style={{ color: q.blocked ? 'var(--text-dark-secondary)' : 'var(--text-dark-primary)', textDecoration: q.blocked ? 'line-through' : 'none' }}>{q.d}</span>
            <span style={{ color: q.blocked ? 'var(--accent)' : 'var(--success)', fontSize: 9, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{q.c}</span>
            <span style={{ color: 'var(--text-dark-faint)', fontSize: 10 }}>{q.t}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function VizNetwork() {
  return (
    <div className="viz-frame" data-label="PRIVATE MESH · 6 PEERS">
      <span className="viz-corner tl"></span><span className="viz-corner tr"></span>
      <span className="viz-corner bl"></span><span className="viz-corner br"></span>
      <svg viewBox="0 0 400 300" className="route-svg" style={{ width: '100%', height: '100%' }}>
        {/* Center node (you) */}
        <g transform="translate(200,150)">
          <circle cx="0" cy="0" r="30" fill="var(--accent-fade)" stroke="var(--accent)" strokeWidth="1.5"/>
          <text x="0" y="3" fontFamily="var(--font-mono)" fontSize="9" fill="var(--accent)" textAnchor="middle" letterSpacing="1">YOU</text>
        </g>
        {/* Peer nodes */}
        {[
          { x: 80, y: 60, name: 'mac-studio-01', live: true },
          { x: 320, y: 60, name: 'lin-server-04', live: true },
          { x: 50, y: 200, name: 'mac-mini-jp', live: true },
          { x: 350, y: 200, name: 'home-nas', live: false },
          { x: 200, y: 270, name: 'phone-pixel', live: true },
        ].map((p, i) => (
          <g key={i}>
            <path d={`M200 150 L${p.x} ${p.y}`} className={`route-line ${p.live ? 'live' : ''}`} />
            <circle cx={p.x} cy={p.y} r="14" fill="var(--bg-light-card)" stroke={p.live ? 'var(--accent)' : 'var(--border-light)'} strokeWidth="1"/>
            <circle cx={p.x} cy={p.y} r="3" fill={p.live ? 'var(--accent)' : 'var(--text-light-faint)'}/>
            <text x={p.x} y={p.y + 30} fontFamily="var(--font-mono)" fontSize="8" fill="var(--text-light-muted)" textAnchor="middle" letterSpacing="0.5">{p.name}</text>
          </g>
        ))}
        {/* Outer dashed perimeter */}
        <rect x="20" y="20" width="360" height="260" fill="none" stroke="var(--accent)" strokeWidth="1" strokeDasharray="2 6" opacity="0.4"/>
      </svg>
    </div>
  );
}

function VizAI() {
  return (
    <div className="viz-frame" data-label="MCP TOKEN · scoped · read-only">
      <span className="viz-corner tl"></span><span className="viz-corner tr"></span>
      <span className="viz-corner bl"></span><span className="viz-corner br"></span>
      <div style={{ background: 'var(--bg-dark-card)', border: '1px solid var(--border-dark)', borderRadius: 3, padding: 14, fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-dark-secondary)', marginBottom: 12 }}>
        <div style={{ fontSize: 9, color: 'var(--text-dark-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 8 }}>scopes</div>
        {[
          { s: 'read:apps', on: true },
          { s: 'read:devices', on: true },
          { s: 'write:apps', on: false },
          { s: 'write:billing', on: false },
        ].map((s, i) => (
          <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', color: s.on ? 'var(--accent)' : 'var(--text-dark-faint)' }}>
            <span>{s.s}</span>
            <span style={{ fontSize: 9, textTransform: 'uppercase' }}>{s.on ? '● ON' : '○ off'}</span>
          </div>
        ))}
      </div>
      <div style={{ background: 'var(--bg-dark)', border: '1px solid var(--border-dark)', borderRadius: 3, padding: 14, fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-dark-secondary)' }}>
        <div style={{ fontSize: 9, color: 'var(--text-dark-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 8 }}>activity</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}><span><span style={{ color: 'var(--accent)' }}>●</span> claude-3.5</span><span style={{ color: 'var(--text-dark-faint)' }}>2s ago</span></div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}><span><span style={{ color: 'var(--success)' }}>●</span> approved · GET /apps</span><span style={{ color: 'var(--text-dark-faint)' }}>2s ago</span></div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}><span><span style={{ color: 'var(--danger)' }}>●</span> denied · POST /billing</span><span style={{ color: 'var(--text-dark-faint)' }}>5s ago</span></div>
      </div>
    </div>
  );
}

function VizGateway() {
  return (
    <div className="viz-frame" data-label="CONTROLLED EGRESS · TASK active-2k7">
      <span className="viz-corner tl"></span><span className="viz-corner tr"></span>
      <span className="viz-corner bl"></span><span className="viz-corner br"></span>
      <div style={{ padding: 16, background: 'var(--bg-light-card)', border: '1px solid var(--border-light)', borderRadius: 2, marginBottom: 12 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-light-primary)' }}>scrape-pricing-data</span>
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 9, color: 'var(--accent)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>● live</span>
        </div>
        <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--text-light-muted)', marginBottom: 4 }}>requests · 421 of 500 cap</div>
        <div style={{ height: 4, background: 'var(--border-light)', borderRadius: 2, marginBottom: 12, overflow: 'hidden' }}>
          <div style={{ width: '84%', height: '100%', background: 'var(--accent)', position: 'relative' }}>
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)', animation: 'shimmer 1.6s linear infinite' }}></div>
          </div>
        </div>
        <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--text-light-muted)', marginBottom: 4 }}>data · 12.4 MB of 25 MB cap</div>
        <div style={{ height: 4, background: 'var(--border-light)', borderRadius: 2, overflow: 'hidden' }}>
          <div style={{ width: '49.6%', height: '100%', background: 'var(--success)' }}></div>
        </div>
        <style>{`@keyframes shimmer { from { transform: translateX(-100%); } to { transform: translateX(100%); } }`}</style>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
        {[
          { l: 'Region', v: 'eu-west' },
          { l: 'Method', v: 'GET only' },
          { l: 'Abuse checks', v: '0' },
        ].map((m, i) => (
          <div key={i} style={{ padding: 10, background: 'var(--bg-light-card)', border: '1px solid var(--border-light)', borderRadius: 2 }}>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 9, color: 'var(--text-light-muted)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>{m.l}</div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-light-primary)', marginTop: 4 }}>{m.v}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function VizExitNodes() {
  return (
    <div className="viz-frame" data-label="EXIT NODES · early access" style={{ background: 'var(--bg-dark-alt)' }}>
      <span className="viz-corner tl"></span><span className="viz-corner tr"></span>
      <span className="viz-corner bl"></span><span className="viz-corner br"></span>
      <svg viewBox="0 0 400 300" style={{ width: '100%', height: '100%' }}>
        {/* World-ish layout */}
        <text x="20" y="30" fontFamily="var(--font-mono)" fontSize="9" fill="var(--text-dark-muted)" letterSpacing="1">ELIGIBLE TRUSTED DEVICES</text>
        {[
          { x: 80, y: 100, label: 'home-mac', region: 'us-east', live: true },
          { x: 200, y: 80, label: 'office-pc', region: 'eu-west', live: true },
          { x: 320, y: 110, label: 'studio-01', region: 'ap-tok', live: false },
          { x: 130, y: 200, label: 'lab-srv', region: 'us-west', live: true },
          { x: 280, y: 220, label: 'home-nas', region: 'eu-cnt', live: false },
        ].map((d, i) => (
          <g key={i}>
            <circle cx={d.x} cy={d.y} r="16" fill="var(--bg-dark-card)" stroke={d.live ? 'var(--accent)' : 'var(--border-dark-strong)'} strokeWidth="1"/>
            <circle cx={d.x} cy={d.y} r="3" fill={d.live ? 'var(--accent)' : 'var(--text-dark-faint)'}/>
            <text x={d.x} y={d.y - 24} fontFamily="var(--font-mono)" fontSize="9" fill="var(--text-dark-secondary)" textAnchor="middle">{d.label}</text>
            <text x={d.x} y={d.y + 32} fontFamily="var(--font-mono)" fontSize="8" fill="var(--text-dark-muted)" textAnchor="middle" letterSpacing="0.5">{d.region}</text>
          </g>
        ))}
        <rect x="10" y="10" width="380" height="280" fill="none" stroke="var(--accent)" strokeWidth="1" strokeDasharray="2 6" opacity="0.3"/>
      </svg>
    </div>
  );
}

// ========= Use cases =========
function UseCases() {
  const cases = [
    { num: '01', title: 'Share Grafana with a friend', body: "Your dashboard runs on your home machine. They open a private link, log in, see real-time graphs. No screenshots, no Zoom share." },
    { num: '02', title: 'Give your AI a safe scope', body: "Hand Claude or your agent a token that can read apps and devices but never touch billing. Approve every write inline." },
    { num: '03', title: 'Open one Postgres to your team', body: "Three engineers need the staging DB. Don't give them your IP — give them a private hostname and revoke any time." },
    { num: '04', title: 'Demo a Jupyter notebook live', body: "Your model trains on a workstation under your desk. A reviewer in another country runs it from their browser. No cloud rebuild." },
    { num: '05', title: 'Reach your home server from anywhere', body: "Your NAS, Home Assistant, or media server — accessible to you (and only you) from any laptop, no VPN client to install." },
    { num: '06', title: 'Block ads and trackers across the family', body: "Secure DNS profile applied to every household device. Block categories, audit blocked queries, no agent on phones." },
  ];
  return (
    <section className="section section-light" id="use-cases">
      <div className="container">
        <div className="section-h">
          <span className="section-label on-light">Use cases</span>
          <h2>Six ways people actually use it.</h2>
          <p>named.network isn't a corporate VPN and it isn't a consumer browsing tunnel. It's a tool for sharing the things you run with the people (and AI agents) who should have access — and nobody else.</p>
        </div>
        <div className="usecase-grid">
          {cases.map((c, i) => (
            <div key={i} className="usecase-card reveal" style={{ animationDelay: `${i*60}ms` }}>
              <div className="uc-icon" style={{ width: 32, height: 32, fontSize: 11 }}>{c.num}</div>
              <h3>{c.title}</h3>
              <p>{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ========= Service grid =========
function ServiceGrid() {
  const services = [
    { tag: 'CORE', title: 'Protected Apps', body: 'Share any local app over a private link.', href: 'protected-apps.html' },
    { tag: 'CORE', title: 'Devices', body: 'Enroll computers with a single command.', href: 'https://app.named.network/dashboard/devices' },
    { tag: 'CORE', title: 'Access', body: 'Invite people, manage access, revoke any time.', href: 'https://app.named.network/dashboard/access' },
    { tag: 'CORE', title: 'Billing', body: 'Plan, usage, and limits in plain language.', href: 'https://app.named.network/dashboard/billing' },
    { tag: 'ADVANCED', title: 'Secure DNS', body: 'Block ads, trackers, and threats per device.', href: 'secure-dns.html', beta: true },
    { tag: 'ADVANCED', title: 'Private Network', body: 'Mesh between your devices, no gateway.', href: 'private-network.html', beta: true },
    { tag: 'BUSINESS', title: 'AI & Automation', body: 'Scoped MCP tokens for safe agent access.', href: 'ai.html', beta: true },
    { tag: 'EARLY ACCESS', title: 'Exit Nodes', body: 'Trusted-device outbound for advanced flows.', href: 'exit-nodes.html', beta: true },
  ];
  return (
    <section className="section section-light-alt" id="services">
      <div className="container">
        <div className="section-h">
          <span className="section-label on-light">All services</span>
          <h2>Eight focused services. One workspace.</h2>
          <p>Start with the basics. Turn on the rest as you need them. Everything is honest about its maturity — beta is labelled, early access is labelled, no surprises.</p>
        </div>
        <div className="svc-grid">
          {services.map((s, i) => (
            <a key={i} href={s.href} className={`svc-tile ${s.beta ? 'beta' : ''}`}>
              <span className="svc-tag">{s.tag}{s.beta ? ' · BETA' : ''}</span>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
              <span className="svc-arrow">Learn more <Icon.arrow /></span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

// ========= Testimonials =========
function Testimonials() {
  const quotes = [
    { quote: "I shipped a private internal tool for the whole team in an afternoon. No more 'works on my Tailscale, broken on Cloudflare Tunnel'.", name: 'Maya R.', role: 'Staff engineer · fintech', initial: 'M' },
    { quote: "Finally gave my AI agent read access to our staging APIs without giving it the keys to production. Scoped tokens just work.", name: 'Devansh K.', role: 'CTO · seed startup', initial: 'D' },
    { quote: "I run a homelab. named.network replaced three things I cobbled together with WireGuard + dynamic DNS + a sketchy reverse proxy.", name: 'Lila S.', role: 'Hobbyist · self-hosting', initial: 'L' },
  ];
  return (
    <section className="section section-light">
      <div className="container">
        <div className="section-h">
          <span className="section-label on-light">From the early users</span>
          <h2 style={{ maxWidth: 720, margin: '14px auto 0' }}>People are already using it for the things we hoped.</h2>
        </div>
        <div className="testimonials-grid">
          {quotes.map((q, i) => (
            <div key={i} className="testimonial reveal" style={{ animationDelay: `${i*80}ms` }}>
              <blockquote>{q.quote}</blockquote>
              <div className="testimonial-meta">
                <div className="testimonial-avatar">{q.initial}</div>
                <div>
                  <div className="testimonial-name">{q.name}</div>
                  <div className="testimonial-role">{q.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ========= Free callout =========
function FreeCallout() {
  return (
    <section className="section section-light-alt" id="pricing">
      <div className="container">
        <div className="free-callout">
          <div className="free-callout-content">
            <span className="section-label on-light">Pricing</span>
            <h3>Free for personal use. Forever.</h3>
            <p>Two devices and one protected app. Plenty for a homelab or a side project. Upgrade when you need more apps, more devices, or teammates.</p>
          </div>
          <div className="free-cta">
            <a href="/pricing" className="btn btn-on-light btn-lg"><span>See full pricing <Icon.arrow /></span></a>
          </div>
        </div>
      </div>
    </section>
  );
}

// ========= Final CTA =========
function FinalCTA() {
  return (
    <section className="section section-dark" style={{ padding: '128px 0' }}>
      <div className="dark-grid"></div>
      <div className="dark-glow"></div>
      <div className="container">
        <div className="cta-final">
          <span className="section-label">Start in 60 seconds</span>
          <h2>One command.<br/>Your apps, private.</h2>
          <p>Run the install, sign in, pick an app. The dashboard shows it in less time than it takes to read this paragraph twice.</p>
          <div style={{ marginTop: 36, maxWidth: 640, marginLeft: 'auto', marginRight: 'auto' }}>
            <div className="terminal-card" style={{ textAlign: 'left' }}>
              <div className="terminal-head">
                <span className="terminal-meta">~ install · one step</span>
                <button className="terminal-tab"><Icon.copy /> copy</button>
              </div>
              <div className="terminal-body">
                <div><span className="prompt">$</span><span className="com">curl -fsSL https://named.network/install.sh | sh</span></div>
              </div>
            </div>
          </div>
          <div className="ctas">
            <a href="https://app.named.network/signup" className="btn btn-accent btn-lg"><span>Create your workspace <Icon.arrow /></span></a>
            <a href="https://app.named.network/login" className="btn btn-on-dark btn-lg"><span>Sign in</span></a>
          </div>
        </div>
      </div>
    </section>
  );
}

// ========= App =========
function App() {
  return (
    <>
      <SiteNav />
      <main id="main-content">
      <Hero />
      <ProductPreview />
      <HowItWorks />

      <ServiceBlock
        flip={false}
        dark={false}
        label="01 · PROTECTED APPS"
        title="Make any local app a private link."
        lead="The thing you actually want to do — share grafana, jupyter, your home server, that one weird service — without becoming a part-time network engineer."
        problem="Buy a static IP. Open ports 80/443. Set up DNS. Get a TLS cert. Pray nothing on the open internet finds you."
        solution="Install the agent. Pick an app. Done. A private hostname like grafana.acme.named.network only your invited people can open."
        cta="See Protected Apps"
        href="/protected-apps"
        viz={<VizProtectedApp />}
      />

      <ServiceBlock
        flip={true}
        dark={true}
        label="02 · DEVICES"
        title="One command. The agent does the rest."
        lead="Every computer that joins your workspace becomes a host for your apps. The agent finds them automatically — no config files, no service unit edits."
        problem="Edit /etc/something.conf. Forget which file. Restart five times. Realize the firewall was the problem all along."
        solution="One curl command on each computer. We detect what's running and ask you which to share. Heartbeat, status, and remote disable from the dashboard."
        cta="See Devices"
        href="https://app.named.network/dashboard/devices"
        viz={<VizDevices />}
      />

      <ServiceBlock
        flip={false}
        dark={false}
        label="03 · ACCESS"
        title="Invite a person. Revoke a person."
        lead="No shared credentials. No corporate-IT-style provisioning. Type an email, send the invite, they sign in once, the link works. Take it back any time."
        problem="Generate a token. Email it. Hope they don't paste it in Slack. Find out a year later it's still valid."
        solution="Email-based invites, workspace roles, and app access rules. Pending requests appear in the dashboard. Revoke instantly with a click."
        cta="See Access"
        href="https://app.named.network/dashboard/access"
        viz={<VizAccess />}
      />

      <ServiceBlock
        flip={true}
        dark={true}
        label="04 · SECURE DNS"
        title="Block ads. Block trackers. Block sketchy stuff."
        lead="Set up a profile, pick categories, assign it to a device. Every DNS query from that device runs through our resolvers — no agent required for phones and tablets."
        problem="Pi-hole on a Raspberry Pi. Goes down when the SD card dies. Doesn't follow you off the home network."
        solution="Hosted DNS profiles with category blocking, allow/block rules, and a query log. Per-device assignment. Works on Wi-Fi, cellular, anywhere."
        cta="See Secure DNS"
        href="/secure-dns"
        viz={<VizDNS />}
      />

      <ServiceBlock
        flip={false}
        dark={false}
        label="05 · PRIVATE NETWORK"
        title="A mesh between your machines."
        lead="Your laptop, your home server, your work workstation, your phone — all reachable to each other directly, no central gateway choking the link."
        problem="WireGuard configs you copy-paste. Routing tables. Wondering why ping works but DNS doesn't."
        solution="Auto-meshed peers with health, route status, and direct private links. Each device sees the others by name. No subnet math."
        cta="See Private Network"
        href="/private-network"
        viz={<VizNetwork />}
      />

      <ServiceBlock
        flip={true}
        dark={true}
        label="06 · AI & AUTOMATION"
        title="Give your agent a key, not the keys."
        lead="MCP-native. Hand Claude, your agent, or a script a scoped token. It can read what you allow, write only what you approve, and you see every call."
        problem="Generate an admin token. Paste it into the agent's config. Cross fingers. Read the bill later."
        solution="Per-scope automation tokens with optional expiry, hosted MCP endpoint, and an audit log of every approval and denial."
        cta="See AI & Automation"
        href="/ai"
        viz={<VizAI />}
      />

      <ServiceBlock
        flip={false}
        dark={false}
        label="07 · CONTROLLED GATEWAY"
        title="Bounded outbound for the times you really need it."
        lead="Sometimes a script genuinely needs to fetch something from the open internet. Caps, regions, abuse checks, and an explicit purpose statement — not a free-for-all proxy."
        problem='"Just route everything through this proxy." Six months later you find out it was scraping for someone else.'
        solution="Per-task sessions with request and data caps, region picker, and a stated purpose. Stop a task instantly. Audit the rest."
        cta="See Controlled Gateway"
        href="/controlled-gateway"
        viz={<VizGateway />}
      />

      <ServiceBlock
        flip={true}
        dark={true}
        label="08 · EXIT NODES"
        title="Trusted-device egress. (Early access.)"
        lead="Use one of your own enrolled, trusted devices as an outbound point — for the rare workflow that needs it. We're explicit: this is not a consumer browsing VPN."
        problem='"Just buy a VPN." Sketchy logs, sketchy ownership, sketchy speed.'
        solution="Use a device you already own and trust as the exit point. Choose eligible devices, set session policy, and review history from the dashboard while the surface stays in early access."
        cta="See Exit Nodes"
        href="/exit-nodes"
        viz={<VizExitNodes />}
      />

      <UseCases />
      <ServiceGrid />
      <Testimonials />
      <FreeCallout />
      <FinalCTA />
      </main>
      <SiteFooter />
    </>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(<App />);

